<app-favorite-vehicle [size]="20" [favorite]="isFavorite" (toggleFavorite)="toggleFavorite()" [color]="color"></app-favorite-vehicle>
